import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { AxiosInstance } from "../axios/index";
// import io from "socket.io-client";
// import { SOCKET_URL } from "../axios";
// import { disconnectSocket } from "../pages/dashboard/SocketInstance";
// const socket = io(SOCKET_URL, {
//   path: "/socket.io", // optional; default is already this
//   transports: ["websocket"],
// });
export const UserContext = React.createContext();

const UserDetailsContextProvider = (props) => {
  const [user, setUser] = useState();
  useEffect(() => {
    const stored = localStorage.getItem("userDetails");
    if (stored) {
      const parsed = JSON.parse(stored);
      sessionStorage.setItem("userDetails", stored);
      sessionStorage.setItem(
        "menu_list",
        JSON.stringify(parsed?.menu_list || [])
      );
      setUser(parsed);
    } else {
      setUser(null);
    }
  }, []);

  //login user details
  const loginUser = (arg, callback) => {
    sessionStorage.setItem("userDetails", JSON.stringify(arg));
    localStorage.setItem("userDetails", JSON.stringify(arg));
    setUser(arg);
    callback();
  };
  //logout user details
  const logout = () => {
    AxiosInstance.post(`api/user/logout`, {
      user_id: user.user_id,
    })
      .then((res) => {
        if (res.status === 200) {
          // disconnectSocket();
          setUser("");
          window.location.href = "/login";
          sessionStorage.removeItem("userDetails");
          sessionStorage.removeItem("menu_list");
          sessionStorage.removeItem("stateRefreshs", true);
          sessionStorage.removeItem("stateRefreshs_test", true);
          sessionStorage.removeItem("stateRefreshs_spl", true);
          sessionStorage.removeItem("stateRefreshs_model", true);
          sessionStorage.removeItem("stateRefreshs_mock", true);
          sessionStorage.removeItem("stateRefreshs_coun", true);
          sessionStorage.removeItem("user_id", true);
          sessionStorage.removeItem("role_id", true);
          sessionStorage.removeItem("Is_remember", true);
          sessionStorage.removeItem("active_user_count", true);
          localStorage.removeItem("userDetails");
          localStorage.removeItem("stateRefreshs", true);
          localStorage.removeItem("stateRefreshs_test", true);
          localStorage.removeItem("stateRefreshs_spl", true);
          localStorage.removeItem("stateRefreshs_model", true);
          localStorage.removeItem("stateRefreshs_mock", true);
          localStorage.removeItem("stateRefreshs_coun", true);
          localStorage.removeItem("user_id", true);
          localStorage.removeItem("role_id", true);
          localStorage.removeItem("Is_remember", true);
          localStorage.removeItem("active_user_count", true);
        } else {
          Swal.fire({
            title: "warning",
            text: res.data.message,
            icon: "warning",
            confirmButtonText: "Ok",
          });
        }
      })
      .catch((error) => {
        return error;
      });
  };

  return (
    <UserContext.Provider
      // value={{ user: user, login: loginUser, logout: logout }}
      value={{
        user,
        setUserDetails: setUser, // now RoleBasedApp can update user
        userDetails: user,
        login: loginUser,
        logout,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export default UserDetailsContextProvider;
